import { render, staticRenderFns } from "./syslog.vue?vue&type=template&id=2436de6e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "syslog.vue"
export default component.exports